export enum REQUEST_STATUSES {
    pending = 'pending',
    failed = 'failed',
    success = 'success',
    timeout = 'timeout',
    notVerified = 'notVerified',
    withoutResponse = 'withoutResponse',
    notStore = 'notStore'
}

export const AUTH_SERVER_IDS = [30001, 33036, 31127, 35763, 31013, 31130, 35513, 35544, 31082, 81710, 81701, 35655, 35844, 35604];
export const NOT_STORE_SERVER_IDS = [30001];
export const DEFAULT_STORE_REQUEST_TIME = 2000;
export const MAX_TIMEOUT_TIMER = 12000;
